'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _temp, _initialiseProps;

var _events = require('./events');

var Events = _interopRequireWildcard(_events);

var _AppEvents = require('../Core/AppEvents');

var AppEvents = _interopRequireWildcard(_AppEvents);

var _constants = require('./constants');

var Constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A facade which allows application code to interact with the UI Container
 *
 * @class
 */
var UIFacade = (_temp = _class = function () {
  /**
   * @param {AppEventEmitter} outgoingDispatcher
   * @param {AppEventEmitter} UIEventsDispatcher
   */
  function UIFacade(outgoingDispatcher, UIEventsDispatcher) {
    (0, _classCallCheck3.default)(this, UIFacade);

    _initialiseProps.call(this);

    this.props = {
      outgoingDispatcher: outgoingDispatcher,
      eventDispatcher: UIEventsDispatcher,
      display: Constants.DISPLAY_EXPANDED, // expanded, collapsed
      visibility: Constants.VISIBILITY_VISIBLE, // visible, hidden
      state: Constants.STATE_READY, // loading, ready, empty, error, ? partial
      menu: Constants.VISIBILITY_VISIBLE, // visible, hidden
      badge: Constants.VISIBILITY_HIDDEN, // visible, hidden
      settings: Constants.VISIBILITY_HIDDEN, // visible, hidden
      badgeCount: 0,
      isResizing: false
    };
  }

  // MENU API

  (0, _createClass3.default)(UIFacade, [{
    key: 'menu',
    get: function get() {
      return this.props.menu;
    }

    /**
     * Shows the UI container's application menu
     *
     * @method
     */


    /**
     * Hides the UI container's application menu
     *
     * @method
     */

  }, {
    key: 'badge',


    // BADGE API

    /**
     * The visibility of the application badge
     *
     * @readonly
     * @type {string}
     */
    get: function get() {
      return this.props.badge;
    }

    /**
     * Shows a number in the application badge
     *
     * @method
     */


    /**
     * Hides a number in the application badge
     *
     * @method
     */

  }, {
    key: 'badgeCount',


    /**
     * The number to display in in the application badge
     *
     * @type {number}
     */
    get: function get() {
      return this.props.badgeCount;
    }

    /**
     * @ignore
     * @param {number} newCount
     */
    ,
    set: function set(newCount) {
      var _props = this.props,
          eventDispatcher = _props.eventDispatcher,
          outgoingDispatcher = _props.outgoingDispatcher,
          visibility = _props.badge,
          oldCount = _props.badgeCount;

      this.props.badgeCount = newCount;

      if (oldCount !== newCount) {
        eventDispatcher.emit(Events.EVENT_BADGE_COUNTCHANGED, newCount, oldCount);
        outgoingDispatcher.emitAsync(AppEvents.EVENT_BADGE, { visibility: visibility, count: newCount });
      }
    }

    // APP VISIBILITY API

    /**
     * The application visibility property
     *
     * @readonly
     * @type {string}
     */

  }, {
    key: 'visibility',
    get: function get() {
      return this.props.visibility;
    }

    /**
     * Checks if the application is visible
     *
     * @method
     *
     * @return {boolean}
     */


    /**
     * Checks if the application is hidden
     *
     * @method
     *
     * @return {boolean}
     */


    /**
     * Shows the application
     *
     * @method
     */


    /**
     * Hides the application
     *
     * @method
     */

  }, {
    key: 'display',


    // APP DISPLAY / APP LAYOUT API

    /**
     * The application display property
     *
     * @readonly
     * @type {string}
     */
    get: function get() {
      return this.props.display;
    }

    /**
     * Checks if the application is expanded
     *
     * @method
     *
     * @return {boolean}
     */


    /**
     * Checks if the application is collapsed
     *
     * @method
     *
     * @return {boolean}
     */


    /**
     * Collapses the application
     *
     * @method
     */


    /**
     * Expands the application
     *
     * @method
     */

  }, {
    key: 'state',


    // UI STATE API

    /**
     * The UI container state property
     *
     * @readonly
     * @type {string}
     */
    get: function get() {
      return this.props.state;
    }

    /**
     * Checks if the UI is in a loading state
     *
     * @method
     *
     * @return {boolean}
     */


    /**
     * Checks if the UI is in the ready state
     *
     * @method
     *
     * @return {boolean}
     */


    /**
     * Shows a loading indicator
     *
     * @method
     */


    /**
     * Hides the active loading indicator
     *
     * @method
     */


    // SETTINGS API

    /**
     * Shows the settings API
     *
     * @method
     */

  }]);
  return UIFacade;
}(), _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.showMenu = function () {
    var _props2 = _this.props,
        eventDispatcher = _props2.eventDispatcher,
        oldVisibility = _props2.menu;

    var newVisibility = Constants.VISIBILITY_VISIBLE;

    if (oldVisibility !== newVisibility) {
      _this.props.menu = newVisibility;
      eventDispatcher.emit(Events.EVENT_MENU_VISIBILITYCHANGED, newVisibility, oldVisibility);
    }
  };

  this.hideMenu = function () {
    var _props3 = _this.props,
        eventDispatcher = _props3.eventDispatcher,
        oldVisibility = _props3.menu;

    var newVisibility = Constants.VISIBILITY_HIDDEN;

    if (oldVisibility !== newVisibility) {
      _this.props.menu = newVisibility;
      eventDispatcher.emit(Events.EVENT_MENU_VISIBILITYCHANGED, newVisibility, oldVisibility);
    }
  };

  this.showBadgeCount = function () {
    var newVisibility = Constants.VISIBILITY_VISIBLE;
    var _props4 = _this.props,
        eventDispatcher = _props4.eventDispatcher,
        outgoingDispatcher = _props4.outgoingDispatcher,
        oldVisibility = _props4.badge;


    if (oldVisibility !== newVisibility) {
      _this.props.badge = newVisibility;
      eventDispatcher.emit(Events.EVENT_BADGE_VISIBILITYCHANGED, newVisibility, oldVisibility);
      outgoingDispatcher.emitAsync(AppEvents.EVENT_BADGE, { visibility: newVisibility, count: _this.badgeCount });
    }
  };

  this.hideBadgeCount = function () {
    var newVisibility = Constants.VISIBILITY_HIDDEN;
    var _props5 = _this.props,
        eventDispatcher = _props5.eventDispatcher,
        outgoingDispatcher = _props5.outgoingDispatcher,
        oldVisibility = _props5.badge;


    if (oldVisibility !== newVisibility) {
      _this.props.badge = newVisibility;
      eventDispatcher.emit(Events.EVENT_BADGE_VISIBILITYCHANGED, newVisibility, oldVisibility);
      outgoingDispatcher.emitAsync(AppEvents.EVENT_BADGE, { visibility: newVisibility, count: _this.badgeCount });
    }
  };

  this.isVisible = function () {
    return _this.props.visibility === Constants.VISIBILITY_VISIBLE;
  };

  this.isHidden = function () {
    return _this.props.visibility === Constants.VISIBILITY_HIDDEN;
  };

  this.show = function () {
    var newVisibility = Constants.VISIBILITY_VISIBLE;
    var _props6 = _this.props,
        eventDispatcher = _props6.eventDispatcher,
        oldVisibility = _props6.visibility;


    if (oldVisibility !== newVisibility) {
      var emit = eventDispatcher.emitCancelable(Events.EVENT_UI_BEFOREVISIBILITYCHANGED, function () {
        _this.props.visibility = newVisibility;
      });

      emit(Events.EVENT_UI_VISIBILITYCHANGED, newVisibility, oldVisibility);
    }
  };

  this.hide = function () {
    var newVisibility = Constants.VISIBILITY_HIDDEN;
    var _props7 = _this.props,
        eventDispatcher = _props7.eventDispatcher,
        oldVisibility = _props7.visibility;


    if (oldVisibility !== newVisibility) {
      var emit = eventDispatcher.emitCancelable(Events.EVENT_UI_BEFOREVISIBILITYCHANGED, function () {
        _this.props.visibility = newVisibility;
      });

      emit(Events.EVENT_UI_VISIBILITYCHANGED, newVisibility, oldVisibility);
    }
  };

  this.isExpanded = function () {
    return _this.props.display === Constants.DISPLAY_EXPANDED;
  };

  this.isCollapsed = function () {
    return _this.props.display === Constants.DISPLAY_COLLAPSED;
  };

  this.collapse = function () {
    var newDisplay = Constants.DISPLAY_COLLAPSED;
    var _props8 = _this.props,
        eventDispatcher = _props8.eventDispatcher,
        oldDisplay = _props8.display;


    if (oldDisplay !== newDisplay) {
      var emit = eventDispatcher.emitCancelable(Events.EVENT_UI_BEFOREDISPLAYCHANGED, function () {
        _this.props.display = newDisplay;
      });

      emit(Events.EVENT_UI_DISPLAYCHANGED, newDisplay, oldDisplay);
    }
  };

  this.expand = function () {
    var newDisplay = Constants.DISPLAY_EXPANDED;
    var _props9 = _this.props,
        eventDispatcher = _props9.eventDispatcher,
        oldDisplay = _props9.display;


    if (oldDisplay !== newDisplay) {
      var emit = eventDispatcher.emitCancelable(Events.EVENT_UI_BEFOREDISPLAYCHANGED, function () {
        _this.props.display = newDisplay;
      });

      emit(Events.EVENT_UI_DISPLAYCHANGED, newDisplay, oldDisplay);
    }
  };

  this.isLoading = function () {
    return _this.props.state === Constants.STATE_LOADING;
  };

  this.isReady = function () {
    return _this.props.state === Constants.STATE_READY;
  };

  this.showLoading = function () {
    var _props10 = _this.props,
        eventDispatcher = _props10.eventDispatcher,
        state = _props10.state;


    if (state !== Constants.STATE_LOADING) {
      _this.props.state = Constants.STATE_LOADING;
      eventDispatcher.emit(Events.EVENT_UI_STATECHANGED, Constants.STATE_LOADING, state);
    }
  };

  this.hideLoading = function () {
    var _props11 = _this.props,
        eventDispatcher = _props11.eventDispatcher,
        state = _props11.state;


    if (state === Constants.STATE_LOADING) {
      _this.props.state = Constants.STATE_READY;
      eventDispatcher.emit(Events.EVENT_UI_STATECHANGED, Constants.STATE_READY, state);
    }
  };

  this.showSettings = function () {
    var newVisibility = Constants.VISIBILITY_VISIBLE;
    var _props12 = _this.props,
        eventDispatcher = _props12.eventDispatcher,
        oldVisibility = _props12.settings;


    if (oldVisibility !== newVisibility) {
      _this.props.settings = newVisibility;
      eventDispatcher.emit(Events.EVENT_SETTINGS_VISIBILITYCHANGED, newVisibility, oldVisibility);
    }
  };
}, _temp);
exports.default = UIFacade;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/UI/UIFacade.js
// module id = 329
// module chunks = 0